// removed by extract-text-webpack-plugin
module.exports = {"root":"EnterpriseButton__root___19kkN","primary":"EnterpriseButton__primary___2bw5A","secondary":"EnterpriseButton__secondary___Jnf5Z","tertiary":"EnterpriseButton__tertiary___172Gu","warning":"EnterpriseButton__warning___2YS_H","danger":"EnterpriseButton__danger___2Gcjt","disabled":"EnterpriseButton__disabled___3Kgox","small":"EnterpriseButton__small___1d5S8","medium":"EnterpriseButton__medium___3eyfx","big":"EnterpriseButton__big___23jac","hero":"EnterpriseButton__hero___2XyGH","fill":"EnterpriseButton__fill___zEOq6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseButton/EnterpriseButton.scss
// module id = 1004
// module chunks = 0